import React, { useState } from "react";
import "./Attendance.css";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";

const getStatusColor = (status) => {
  switch (status) {
    case "AL":
      return "#7BD3EA";
    case "SL":
      return "#7BD3EA";
    case "CL":
      return "#7BD3EA";
    case "CO":
      return "#7BD3EA";
    case "PL":
      return "#7BD3EA";
    case "LWP":
      return "#7BD3EA";
    case "P":
      return "#A1EEBD";
    case "A":
      return "#FB4141";
    case "H-1":
      return "#F3B95F";
    case "H-2":
      return "#F3B95F";
    case "WO":
      return "rgba(158, 158, 158, 0.9)";
    case "H":
      return "#F3B95F";
    case "HL":
      return "#E1AFD1";
    default:
      return "#FFE0EF";
  }
};

const Attendance = ({ attendanceData }) => {
  const [currentView, setCurrentView] = useState("monthly");
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const [showProjects, setShowProjects] = useState(true);
  // Ensure attendanceData is an array, if not use empty array
  const safeAttendanceData = Array.isArray(attendanceData)
    ? attendanceData
    : [];

  // Process the data from props
  const processData = (data) => {
    return data.map((item) => {
      const date = new Date(item.date);
      return {
        date: date.getDate(),
        status: item.type,
        fullDate: date,
        month: date.toLocaleString("default", { month: "short" }),
        day: item.day,
      };
    });
  };

  const allData = processData(safeAttendanceData);

  // Generate weekly grid in chronological order
  const generateWeeklyGrid = () => {
    if (!allData.length) return [];

    // Get the last 7 days
    const latestDate = new Date(Math.max(...allData.map((d) => d.fullDate)));
    const startDate = new Date(latestDate);
    startDate.setDate(latestDate.getDate() - 6); // 7 days including start

    // Create a map of date strings to data for quick lookup
    const dataMap = {};
    allData.forEach((item) => {
      dataMap[item.fullDate.toISOString().split("T")[0]] = item;
    });

    // Generate 7-day grid in chronological order
    const grid = [];
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      const dateString = currentDate.toISOString().split("T")[0];
      grid.push(
        dataMap[dateString] || {
          date: currentDate.getDate(),
          status: null,
          fullDate: currentDate,
          month: currentDate.toLocaleString("default", { month: "short" }),
          day: daysOfWeek[currentDate.getDay()],
        }
      );
    }

    return grid;
  };

  const weeklyGrid = generateWeeklyGrid();

  // Create a 30-day grid for monthly view
  const generateMonthlyGrid = () => {
    if (!allData.length) return [];

    // Find the date range (last 30 days from the latest date)
    const latestDate = new Date(Math.max(...allData.map((d) => d.fullDate)));
    const startDate = new Date(latestDate);
    startDate.setDate(latestDate.getDate() - 29); // 30 days including start

    // Create a map of date strings to data for quick lookup
    const dataMap = {};
    allData.forEach((item) => {
      dataMap[item.fullDate.toISOString().split("T")[0]] = item;
    });

    // Generate 30-day grid
    const grid = [];
    let currentWeek = [];
    for (let i = 0; i < 30; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      const dateString = currentDate.toISOString().split("T")[0];
      const dayOfWeek = currentDate.getDay(); // 0 = Sun, 1 = Mon, etc.

      // Only include days that belong in the current week row
      if (i > 0 && dayOfWeek === 0) {
        grid.push(currentWeek);
        currentWeek = [];
      }

      currentWeek[dayOfWeek] = dataMap[dateString] || {
        date: currentDate.getDate(),
        status: null,
        fullDate: currentDate,
        month: currentDate.toLocaleString("default", { month: "short" }),
        day: daysOfWeek[dayOfWeek],
      };
    }

    // Push the last week
    if (currentWeek.length) {
      grid.push(currentWeek);
    }

    return grid;
  };

  const monthlyGrid = generateMonthlyGrid();

  const getHeaderText = () => {
    if (currentView === "weekly") {
      return `Last 7 Days Attendance`;
    } else {
      return `Last 30 Days Attendance`;
    }
  };

  return (
    <div className="attendance-card" style={{ width: "100%" }}>
      <div className="card-header" style={{ backgroundColor: "#004085" }}>
        <h3 style={{ color: "white" }}>{getHeaderText()}</h3>
        <div className="view-toggle">
          <button
            className={currentView === "weekly" ? "active" : ""}
            onClick={() => setCurrentView("weekly")}
          >
            Weekly
          </button>
          <button
            className={currentView === "monthly" ? "active" : ""}
            onClick={() => setCurrentView("monthly")}
          >
            Monthly
          </button>
          <button
            onClick={() => setShowProjects((prev) => !prev)}
            style={{
              backgroundColor: "#fff",
              color: "#004085",
              border: "none",
              padding: "3px 5px",
              borderRadius: "100%",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
            }}
          >
            {showProjects ? <FaMinusCircle /> : <FaPlusCircle />}
          </button>
        </div>
      </div>
      {showProjects && (
        <>
          <div className="days-header">
            {weeklyGrid.length > 0 && currentView === "weekly"
              ? weeklyGrid.map((dayData, index) => (
                  <div key={index} className="day-label">
                    {dayData.fullDate.toLocaleString("default", {
                      weekday: "short",
                    })}
                  </div>
                ))
              : daysOfWeek.map((day, index) => (
                  <div key={index} className="day-label">
                    {day}
                  </div>
                ))}
          </div>

          {currentView === "weekly" ? (
            <div className="attendance-grid">
              {weeklyGrid.map((dayData, index) => (
                <div
                  key={index}
                  className="attendance-day"
                  style={{
                    backgroundColor: dayData?.status
                      ? getStatusColor(dayData.status)
                      : "#FFFFFF",
                  }}
                  title={
                    dayData
                      ? `${dayData.fullDate.toDateString()}${
                          dayData.status ? `: ${dayData.status}` : ""
                        }`
                      : ""
                  }
                >
                  <span className="date-number">
                    {dayData ? dayData.date : ""}
                  </span>
                  {dayData?.status && (
                    <span className="status-label">{dayData.status}</span>
                  )}
                </div>
              ))}
            </div>
          ) : (
            monthlyGrid.map((week, weekIndex) => (
              <div key={weekIndex} className="attendance-grid">
                {daysOfWeek.map((_, dayIndex) => {
                  const dayData = week[dayIndex];
                  return (
                    <div
                      key={dayIndex}
                      className="attendance-day"
                      style={{
                        backgroundColor: dayData?.status
                          ? getStatusColor(dayData.status)
                          : "#FFFFFF",
                      }}
                      title={
                        dayData
                          ? `${dayData.fullDate.toDateString()}${
                              dayData.status ? `: ${dayData.status}` : ""
                            }`
                          : ""
                      }
                    >
                      <span className="date-number">
                        {dayData ? dayData.date : ""}
                      </span>
                      {dayData?.status && (
                        <span className="status-label">{dayData.status}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            ))
          )}
        </>
      )}
    </div>
  );
};

export default Attendance;
